import { convertObjectValuesToStrings } from '@inkitt/utils-conversions';

export const setQueryParamsInUrl = (url: URL, query?: Record<string, unknown>): string => {
  if (!query) {
    return url.toString();
  }

  const stringQuery = convertObjectValuesToStrings(query);
  Object.entries(stringQuery).map(([key, value]) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
};

export const addQueryParam = (query?: Record<string, unknown>) => {
  const url = new URL(window.location.href);

  return setQueryParamsInUrl(url, query);
};

export const removeQueryParamsFromUrl = (paramKeys: string[], searchParams: URLSearchParams) => {
  const { origin, pathname } = window.location;
  const url = new URL(`${origin}${pathname}`);

  const finalSearchQueryParams: Record<string, string> = {};
  for (const [key, value] of searchParams.entries()) {
    if (!paramKeys.includes(key)) {
      finalSearchQueryParams[key] = value;
    }
  }

  return setQueryParamsInUrl(url, finalSearchQueryParams);
};
